module.exports = __webpack_public_path__ + "41a00eb16205bb06e29fa799d020e946.pdf";